import { useCallback } from 'react';
import { NodeViewProps } from '@tiptap/react';

import { useModal } from 'hooks';

const useNodeActions = (props: NodeViewProps) => {
  const hoverModal = useModal();
  const editModal = useModal();
  const deleteModal = useModal();

  const closeAll = useCallback(() => {
    hoverModal.close();
    editModal.close();
    deleteModal.close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hoverModal.close, editModal.close, deleteModal.close]);

  const handleDelete = useCallback(() => {
    const pos = props.getPos?.();
    if (pos !== undefined && props.editor) {
      props.editor.commands.deleteRange({ from: pos, to: pos + 1 });
      closeAll();
    }
  }, [props, closeAll]);

  return { hoverModal, editModal, deleteModal, closeAll, handleDelete };
};

export default useNodeActions;
